import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    props: {
        name: null,
        size: { default: 16 },
        src: null
    },
    setup(__props) {
        const props = __props;
        const names = computed(() => props.name?.split(" ") ?? []);
        const size = computed(() => parseInt(props.size));
        const initials = computed(() => [names.value[0]?.charAt(0), names.value[names.value.length - 1]?.charAt(0)]
            .join("")
            .toUpperCase());
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "avatar",
                style: _normalizeStyle({ fontSize: `${(_unref(size) * 0.025) + (_unref(size) / 12)}rem`, height: `${_unref(size) * 0.25}rem`, width: `${_unref(size) * 0.25}rem` })
            }, [
                _createElementVNode("span", null, _toDisplayString(_unref(initials)), 1)
            ], 4));
        };
    }
});
